import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { CommandMenuProvider } from "@/components/CommandMenu";
import { Accession } from "@/features/accession/components/Accession";

export const Route = createLazyFileRoute("/_auth/_app/accessions/$id/modal")({
  component: memo(() => {
    const { accession } = Route.useLoaderData();
    return (
      <div className="w-[600px] h-full border-l overflow-scroll">
        <CommandMenuProvider>
          <Accession accession={accession} />
        </CommandMenuProvider>
      </div>
    );
  }),
});
